import styled from '@mui/system/styled';
import { Theme } from '@mui/material';

export const AppWrapper = styled('div')({
  marginBottom: '17px'
});

export const AppLink = styled('a')(({ theme }: { theme?: Theme }) => ({
  display: 'inline-block',
  margin: '0 7px',
  '& svg': {
    width: '98px !important',
    height: '29px !important'
  },
  [theme.breakpoints.up('sm')]: {
    '& svg': {
      width: '110px !important',
      height: '33px !important'
    }
  }
}));

export const SocialLink = styled('a')(({ theme }: { theme?: Theme }) => ({
  margin: '0 9px',
  '& svg': {
    width: '24px',
    height: '28px'
  },
  [theme.breakpoints.up('sm')]: {
    '& svg': {
      width: '28px !important',
      height: '32px !important'
    }
  }
}));

export const Bar = styled('div')(({ theme }: { theme?: Theme }) => ({
  whiteSpace: 'nowrap',
  display: 'flex',
  maxWidth: '100vw',
  paddingTop: '28px',
  marginBottom: '4px',
  '& > *': {
    display: 'inline-block',
    width: '25%',
    height: '25px',
    marginTop: '4px',
    '&: nth-of-type(1)': {
      width: '12%',
      backgroundColor: '#2ac9c6'
    },
    '&: nth-of-type(2)': {
      backgroundColor: '#76d2d0'
    },
    '&: nth-of-type(3)': {
      backgroundColor: '#49c3c1'
    },
    '&: nth-of-type(4)': {
      backgroundColor: '#008584'
    },
    '&: nth-of-type(5)': {
      width: '13%',
      backgroundColor: '#32c8c5'
    }
  },
  [theme.breakpoints.up('md')]: {
    marginBottom: '2px',
    '& > *': {
      height: '35px'
    }
  }
}));

export const ScrollToTopContainer = styled('span')(
  ({ theme }: { theme?: Theme }) => ({
    display: 'inline-block',
    cursor: 'pointer',
    marginTop: '9px',
    '& svg': {
      maxWidth: '25px',
      maxHeight: '40px'
    },

    [theme.breakpoints.up('sm')]: {
      '& svg': {
        maxWidth: '36px',
        maxHeight: '57px'
      }
    },

    [theme.breakpoints.up('md')]: {
      marginTop: '22px'
    }
  })
);
